import { createFileRoute } from '@tanstack/react-router'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { withResourcePermission } from '~/components/RequireResourcePermission'
import { InterimAgenciesPage } from '~/components/routes/hr/interim-agencies/interim-agencies-page'

export const Route = createFileRoute('/_authenticated/hr/interim-agencies')({
  component: withResourcePermission('hr-planning', 'read')(RouteComponent),
})

function RouteComponent() {
  return (
    <>
      <AppHeader>
        <Title>Agences d'intérim</Title>
      </AppHeader>
      <AppContainer>
        <InterimAgenciesPage />
      </AppContainer>
    </>
  )
}
